module.exports = __webpack_public_path__ + "img/glas_5.68a29cd7.png";